import React from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Webhook, Copy, ShieldCheck, ShieldAlert } from "lucide-react";

export const TwilioWebhookCard = ({ cfg }) => {
  const url = cfg?.webhook_url;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("URL du webhook copiée"); }
    catch { toast.error("Copie impossible — sélectionnez l'URL manuellement"); }
  };
  return (
    <div className="p-5 bg-white border border-[#DEE2E6]" data-testid="tw-webhook-card">
      <div className="font-display font-bold text-lg mb-1 flex items-center gap-2">
        <Webhook className="h-5 w-5 text-[#002FA7]" />Accusés de réception (webhook)
      </div>
      <div className="text-[11px] text-[#495057] mb-3">
        Twilio prévient PAG de chaque étape (transmis, livré, non livré). L'URL ci-dessous est transmise automatiquement
        à chaque envoi (<code>StatusCallback</code>) — vous pouvez aussi la coller dans la console Twilio
        (Messaging Service → Integration → Delivery status callback).
      </div>
      {url ? (
        <div className="flex items-stretch gap-2">
          <code className="flex-1 text-[11px] bg-[#F8F9FA] border border-[#DEE2E6] px-2 py-2 break-all" data-testid="tw-webhook-url">{url}</code>
          <Button variant="outline" onClick={copy} data-testid="tw-webhook-copy" className="h-auto"><Copy className="h-4 w-4" /></Button>
        </div>
      ) : (
        <div className="text-[11px] text-[#7F1D1D] bg-[#FEF2F2] border border-[#FCA5A5] p-2" data-testid="tw-webhook-missing">
          URL indisponible : la variable <code>FRONTEND_URL</code> du serveur doit être une adresse <code>https://</code> publique.
        </div>
      )}
      <div className={`mt-3 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-bold px-2 py-1 ${cfg?.webhook_signature_ready ? "bg-[#059669] text-white" : "bg-[#F59E0B] text-white"}`} data-testid="tw-webhook-signature">
        {cfg?.webhook_signature_ready ? <ShieldCheck className="h-3 w-3" /> : <ShieldAlert className="h-3 w-3" />}
        {cfg?.webhook_signature_ready ? "Signature Twilio vérifiée à chaque appel" : "Signature vérifiable dès que l'Auth Token est enregistré"}
      </div>
    </div>
  );
};
